import React from 'react';
import { useUnreadTasks } from '../contexts/UnreadTasksContext';
import { useTasks } from '../contexts/TasksContext';

export default function UnreadTasksBadge() {
  const { unreadCount } = useUnreadTasks();
  const { tasks } = useTasks();
  
  // Count pending tasks
  const pendingTasksCount = tasks.filter(task => task.status === 'pending').length;

  if (pendingTasksCount === 0) return null;

  return (
    <div 
      className={`absolute -top-1 -right-3 flex items-center justify-center ${
        unreadCount > 0 ? 'bg-red-500' : 'bg-gray-600'
      } text-white rounded-full min-w-[16px] h-4 px-1 text-xs font-medium transition-colors duration-200`}
    >
      {pendingTasksCount}
    </div>
  );
} 